import { Row, Col } from "react-grid-system";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Card from "../components/Card";
import FlexBox from "../components/FlexBox";
import { useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { Icon } from "@mui/material";

const BadGatewayCard = styled(Card)`
  text-align: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(
    90deg,
    rgb(71, 85, 105) 0%,
    rgb(50 60 75) 118.29%
  );
`;

function BadGatewayPage() {
  const { signOut } = useContext(UserContext);
  useEffect(() => {
    signOut();
  });
  return (
    <>
      <Row>
        <Col>
          <BadGatewayCard>
            <FlexBox
              direction="column"
              justify="center"
              style={{ height: "100%" }}
              space={3}
              alignItems="center"
            >
              {/* <img src={LogoImage} alt="" style={{ marginBottom: '24px' }} /> */}
              <Icon style={{color:'orange', fontSize:120 }}>
                warning
              </Icon>
              <p>
                Error accessing the "SIMON" back end. Please try again. If the
                problem persists, contact A1CE support team
                <a
                  style={{ padding: "0 5px 0 5px", color: "yellow" }}
                  href="mailto:help@cmkl.ac.th"
                >
                  help@cmkl.ac.th
                </a>
                for assistance.
              </p>
              <p>
                Need to get back in?{" "}
                <a
                  onClick={() => (window.location.pathname = "/signin")}
                  style={{ cursor: "pointer", color: "yellow" }}
                >
                  Sign in again
                </a>
              </p>
            </FlexBox>
          </BadGatewayCard>
        </Col>
      </Row>
    </>
  );
}

export default BadGatewayPage;
